import type * as THREE from 'three';

/**
 * Whether three.js can build a wireframe index for this geometry.
 *
 * `WebGLRenderer` derives wireframe edges on the CPU from
 * `geometry.index.array` (or `attributes.position.array` for non-indexed
 * geometry). `@thatopen/fragments` frees those arrays after the first GPU
 * upload (`attr.onUpload(function () { delete this.array })`), so flipping
 * `material.wireframe` to `true` on a mesh that already rendered solid throws
 * `Cannot read properties of undefined (reading 'length')` inside
 * `updateWireframeAttribute` on every frame. Check this before enabling
 * wireframe on a material whose geometry may already be GPU-resident.
 */
export const canRenderWireframe = (geometry: THREE.BufferGeometry | undefined | null): boolean => {
  if (!geometry) return false;
  const index = geometry.index;
  if (index) return index.array !== undefined && index.array !== null;
  const position = geometry.attributes.position as THREE.BufferAttribute | undefined;
  if (!position) return false;
  return position.array !== undefined && position.array !== null;
};
